<pv-view toolbarTitle="Protocols" [returnTo]="['..']" *ngIf="state$ | async as state">
    <!-- TOOLBAR ACTIONS -->
    <div pv-view-tools>

        <button mat-icon-button (click)="addProtocol(state.orgKey)" matTooltip="Add Protocol" *ngIf="!isReadonly">
            <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button (click)="reloadProtocols()" matTooltip="Refresh Protocol Data">
            <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="reset()" matTooltip="Clear Filters">
            <mat-icon>filter_alt</mat-icon>
        </button>

    </div>
    <!-- TOOLBAR ACTIONS END -->

    <!-- SELECTION TOOLBAR -->
    <mat-toolbar pv-view-header class="cultivar-selection-toolbar mat-elevation-z3" color="accent"
        *ngIf="!selection.isEmpty()">

        <button mat-icon-button (click)="selection.clear()" matTooltip="Clear Selection">
            <mat-icon>clear</mat-icon>
        </button>

        <span class="flex-spacer">
            {{ selection.selected.length }} Protocols Selected
        </span>
    </mat-toolbar>
    <!-- SELECTION TOOLBAR END -->

    <!-- SIDEBAR -->
    <div pv-view-sidebar>
        <mat-tab-group>
            <!-- FILTER TAB -->
            <mat-tab label="Filter">
                <ng-template matTabContent>
                    <form [formGroup]="filterFormProtocol" class="pv-form single-column p-12 cultivar-index-filter-form">
                        <mat-form-field appearance="outline">
                            <mat-label>Search</mat-label>
                            <mat-icon matPrefix>search</mat-icon>
                            <input type="text" matInput formControlName="search" placeholder="Find by title">
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Filter Crop</mat-label>
                            <mat-select formControlName="crop" multiple>
                                <mat-option *ngFor="let crop of cropOptions" [value]="crop.id">
                                    <mat-icon [svgIcon]="'common:' + crop.id"></mat-icon>
                                    <span>{{ crop.label }}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Filter Sample Type</mat-label>
                            <mat-select formControlName="sampleType" multiple>
                                <mat-option *ngFor="let sampleType of sampleTypeOptions" [value]="sampleType.value">
                                    <mat-icon [svgIcon]="'common:' + sampleType.value + '_sample'"></mat-icon>
                                    <span>{{ sampleType.label }}</span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <ng-container>
                            <div class="toggle-wrapper">
                                <div class="form-toggle">
                                    <span>Base Protocols</span>
                                    <mat-slide-toggle formControlName="baseProtocols" color="primary"></mat-slide-toggle>
                                </div>
                                <span class="mat-checkbox-hint">Inculde base protocols</span>
                            </div>
                        </ng-container>

                        <ng-container>
                            <div class="toggle-wrapper">
                                <div class="form-toggle">
                                    <span>Favourites</span>
                                    <mat-slide-toggle formControlName="favourite" color="primary"></mat-slide-toggle>
                                </div>
                                <span class="mat-checkbox-hint">Inculde your organisation's favourite protocols</span>
                            </div>
                        </ng-container>

                        <ng-container>
                            <div class="toggle-wrapper">
                                <div class="form-toggle">
                                    <span>Hidden</span>
                                    <mat-slide-toggle formControlName="hidden" color="primary"></mat-slide-toggle>
                                </div>
                                <span class="mat-checkbox-hint">Inculde protocol hidden by you organisation</span>
                            </div>
                        </ng-container>

                        <div class="form-actions">
                            <button mat-mini-fab (click)="reset()" matTooltip="Clear Filters" color="accent">
                                <mat-icon class="white-icon">filter_alt</mat-icon>
                            </button>
                        </div>
                    </form>
                </ng-template>
            </mat-tab>

            <!-- BULK ACTION TAB -->
            <mat-tab label="Bulk Action" *ngIf="!isReadonly">
                <ng-template matTabContent>
                    <mat-action-list class="cultivar-bulk-actions" dense>
                        <h2 matSubheader>Organization Preference</h2>
                        <mat-divider></mat-divider>
                        <mat-list-item (click)="setBulkPreference(selection.selected, ['favourite', 'hidden'], true)">
                            <mat-icon matListIcon>star</mat-icon>
                            <span matLine>Favourite</span>
                        </mat-list-item>
                        <mat-list-item (click)="setBulkPreference(selection.selected, ['favourite', 'hidden'], false)">
                            <mat-icon matListIcon class="material-symbols-outlined">grade</mat-icon>
                            <span matLine>Unfavourite</span>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                        <mat-list-item (click)="setBulkPreference(selection.selected, ['hidden', 'favourite'], true)">
                            <mat-icon matListIcon>visibility_off</mat-icon>
                            <span matLine>Hide</span>
                        </mat-list-item>
                        <mat-list-item (click)="setBulkPreference(selection.selected, ['hidden', 'favourite'], false)">
                            <mat-icon matListIcon>visibility</mat-icon>
                            <span matLine>Unhide</span>
                        </mat-list-item>
                    </mat-action-list>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    <!-- SIDEBAR END -->

    <!-- PAGINATION FOOTER -->
    <div pv-view-footer class="pv-table-footer">
        <label class="mat-caption mr-12" for="protocol_index_sort">Sort</label>
        <mat-select [formControl]="columnControl"
                    id="protocol_index_sort"
                    class="cultivar-index-sort-select">
            <mat-option *ngFor="let opt of state.sortOptions" [value]="opt.id">
                {{ opt.label }}
            </mat-option>
        </mat-select>

        <button type="button" class="ml-12" mat-icon-button (click)="toggleSortOrder($event)" matTooltip="Change Sort Direction">
            <mat-icon [svgIcon]="orderControl.value === 'asc' ? 'fa:solid-sort-alpha-up' : 'fa:solid-sort-alpha-down'">
            </mat-icon>
        </button>

        <mat-paginator [length]="state.total"
                       [pageSize]="state.page.size"
                       [pageIndex]="state.page.index"
                       (page)="paginate($event)"
                       [pageSizeOptions]="state.pageSizeOptions">
        </mat-paginator>
    </div>
    <!-- PAGINATION FOOTER END -->

    <!-- FAB -->
    <button pv-view-fab mat-fab color="primary" matTooltip="Add Protocol" (click)="addProtocol(state.orgKey)" *ngIf="!isReadonly">
        <mat-icon>add</mat-icon>
    </button>

    <!-- BODY -->
    <div pv-view-body class="cultivar-index-body" [ngSwitch]="state.status">
        <!-- STATUS OVERLAY: LOADING -->
        <pv-view-loader *ngSwitchCase="'LOADING'" message="Loading Protocols..."></pv-view-loader>

        <!-- STATUS MESSAGE: EMPTY -->
        <pv-view-message *ngSwitchCase="'EMPTY'" heading="No results"
                            message="Current filters does not match any Protocols. Update filters or add a Protocol."
                            icon="help">
            <button mat-button color="accent" pvMessageAction (click)="reset()">
                Clear Filters
            </button>
            <button mat-button color="primary" pvMessageAction (click)="addProtocol(state.orgKey)">
                Add Protocol
            </button>
        </pv-view-message>

        <!-- STATUS MESSAGE: ERROR -->
        <pv-view-message *ngSwitchDefault [heading]="state.status | descStatusTitle"
                            [message]="state.status | descStatusMessage:'Protocols'" icon="error">
            <button mat-button
                    color="primary"
                    pvMessageAction
                    (click)="reloadProtocols()">Reload</button>
        </pv-view-message>

        <!-- ngSwitch placeholders -->
        <ng-container *ngSwitchCase="'OK'"></ng-container>

        <!-- GROUP TABLE -->
        <div class="pv-cultivar-table pv-responsive-table" *ngIf="state.status === 'OK' || state.status === 'LOADING'">
            <table
                   cdk-table
                   [dataSource]="state.data"
                   matSort
                   matSortDisableClear="true"
                   (matSortChange)="sort($event)"
                   [matSortActive]="state.sort.column"
                   [matSortDirection]="state.sort.order">

                <ng-container cdkColumnDef="selectionBox">
                    <th cdk-header-cell *cdkHeaderCellDef>
                        <mat-checkbox
                            (change)="$event ? masterToggle(state.data) : null"
                            [checked]="selection.hasValue() && isAllSelected(state.data)"
                            [indeterminate]="selection.hasValue() && !isAllSelected(state.data)" class="no-print">
                        </mat-checkbox>
                    </th>
                    <td cdk-cell *cdkCellDef="let row">
                        <div class="image-overlay no-print" (click)="selection.toggle(row.id)">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row.id) : null"
                                [checked]="selection.isSelected(row.id)">
                            </mat-checkbox>
                        </div>
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="title">
                    <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="title">Title</th>
                    <td cdk-cell *cdkCellDef="let row">
                        <ng-container *ngIf="row.isCustomProtocol; else baseProtocols">
                            <mat-icon *ngIf="!row.hidden && !row.favourite">ballot</mat-icon>
                            <mat-icon *ngIf="row.favourite">star</mat-icon>
                            <mat-icon class="material-symbols-outlined" *ngIf="row.hidden">visibility_off</mat-icon>
                        </ng-container>
                        <ng-template #baseProtocols>
                            <mat-icon class="material-symbols-outlined" *ngIf="!row.hidden && !row.favourite">hub</mat-icon>
                            <mat-icon *ngIf="row.favourite">star</mat-icon>
                            <mat-icon class="material-symbols-outlined" *ngIf="row.hidden">visibility_off</mat-icon>
                        </ng-template>
                        {{ row.title }}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="actions">
                    <th cdk-header-cell *cdkHeaderCellDef></th>
                    <td cdk-cell *cdkCellDef="let row">
                        <button mat-icon-button
                                matTooltip="Protocol Actions"
                                [matMenuTriggerFor]="protocolMenu"
                                [matMenuTriggerData]="{protocol: row}"
                                *ngIf="!isReadonly">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="crop">
                    <th cdk-header-cell *cdkHeaderCellDef>Crop</th>
                    <td cdk-cell *cdkCellDef="let row">
                        <ng-container *ngIf="row | protocolCropDisplay as cropDisplay">
                            <mat-icon *ngIf="cropDisplay.type === 'icon'" [svgIcon]="'common:' + cropDisplay.value" class="mat-24"></mat-icon>
                            <span *ngIf="cropDisplay.type === 'text'" class="protocol-crop-text">{{ cropDisplay.value }}</span>
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="sampleType">
                    <th cdk-header-cell *cdkHeaderCellDef>Type</th>
                    <td cdk-cell *cdkCellDef="let row">
                        <mat-icon *ngIf="row.sampleType == 'plant'" svgIcon="common:plant_sample"></mat-icon>
                        <mat-icon *ngIf="row.sampleType == 'harvest'" svgIcon="common:harvest_sample"></mat-icon>
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="chars">
                    <th class="count-column" cdk-header-cell mat-sort-header="chars" *cdkHeaderCellDef>Characteristics</th>
                    <td class="count-column" cdk-cell *cdkCellDef="let row">
                        {{ row.chars?.length }}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="measures">
                    <th class="count-column" cdk-header-cell mat-sort-header="measures" *cdkHeaderCellDef>Measurements</th>
                    <td class="count-column" cdk-cell *cdkCellDef="let row">
                        {{ row.measures?.length }}
                    </td>
                </ng-container>

                <ng-container cdkColumnDef="indexes">
                    <th class="count-column" cdk-header-cell mat-sort-header="indexes" *cdkHeaderCellDef>Indexes</th>
                    <td class="count-column" cdk-cell *cdkCellDef="let row">
                        {{ row.indexes.length }}
                    </td>
                </ng-container>

                  <ng-container cdkColumnDef="timestamps">
                    <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="createdAt">Timestamps
                    </th>
                    <td cdk-cell *matCellDef="let row">
                        <ng-container *ngIf="row.isCustomProtocol">
                            <span class="caption-line">Added
                                {{ row.createdAt | amDateFormat:'ll' }}</span>
                                <span class="caption-line">Updated
                                    {{ row.updatedAt | amTimeAgo }}</span>
                        </ng-container>
                    </td>
                </ng-container>

                <tr cdk-header-row *cdkHeaderRowDef="state.displayColumns"></tr>
                <tr [class.archived-row]="row.hidden" cdk-row *cdkRowDef="let row; columns: state.displayColumns"></tr>
            </table>
        </div>
        <!-- GROUP TABLE END -->

        <!-- GROUP ACTION MENUS -->
        <mat-menu #protocolMenu>
            <ng-template matMenuContent let-protocol="protocol">
                <button *ngIf="protocol.isCustomProtocol" mat-menu-item (click)="addProtocol(state.orgKey, protocol)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit Protocol</span>
                </button>

                <button *ngIf="(!protocol.favourite && !protocol.hidden) || (protocol.favourite && !protocol.hidden)" mat-menu-item (click)="toggleProtocolPreference(state.orgKey, protocol, 'favourite')">
                    <ng-container *ngIf="!protocol.favourite; else unFavourite">
                        <mat-icon>star</mat-icon>
                        <span>Favourite Protocol</span>
                    </ng-container>
                    <ng-template #unFavourite>
                        <mat-icon class="material-symbols-outlined">grade</mat-icon>
                        <span>Unfavourite Protocol</span>
                    </ng-template>
                </button>

                <button *ngIf="(!protocol.favourite && !protocol.hidden) || (protocol.hidden && !protocol.favourite)" mat-menu-item (click)="toggleProtocolPreference(state.orgKey, protocol, 'hidden')">
                    <ng-container *ngIf="!protocol.hidden; else unHide">
                        <mat-icon>visibility_off</mat-icon>
                        <span>Hide Protocol</span>
                    </ng-container>
                    <ng-template #unHide>
                        <mat-icon>visibility</mat-icon>
                        <span>Unhide Protocol</span>
                    </ng-template>
                </button>
            </ng-template>
        </mat-menu>
        <!-- GROUP ACTION MENUS END -->

    </div>
    <!-- BODY END -->
</pv-view>
